import actionCreatorFactory from 'typescript-fsa'
import { ApplicationState } from '../../../reducers'
import { itemLoading, itemLoaded } from '../loading/actions'
import { loadMenu } from '../../../services/Api'
import { currentEventSelector } from '../../../data/selectors'
import { menuLoaded } from '../../../data/actions'
import Menu from '../../../models/menu'

const actionCreator = actionCreatorFactory('NAV')

const openSubmenu = actionCreator('OPEN_SUBMENU')
const closeSubmenu = actionCreator('CLOSE_SUBMENU')

const loadMenuData = () => {
    return async (dispatch: any, getState: () => ApplicationState) => {
        let menu: Menu

        // TODO: Fetch the correct menu for the current event

        try {
            menu = await loadMenu('menu', false)
        } catch (e) {
            return
        }

        dispatch(menuLoaded(menu))
    }
}

export {
    openSubmenu,
    closeSubmenu,
    loadMenuData,
}
